module.exports = __webpack_public_path__ + "static/media/logo_nav-faith.7a973916.svg";